import { type AgendaEvent, localToday } from '@quadro/domain';
import { useEvents, useOutlook } from '../../data/queries';
import { openSheet } from '../../state/sheets';
import { useUI } from '../../state/ui';

/** Eventos da equipe + Outlook da própria pessoa no período, sem os calendários ocultos. */
export function useAgendaEvents(from: string, to: string): AgendaEvent[] {
  const hidden = useUI(s => s.hiddenCalendars);
  const team = useEvents().data ?? [];
  const outlook = useOutlook(from, to).data?.events ?? [];
  return [...team, ...outlook].filter(e => !hidden.includes(e.calendar));
}

/** Se a pessoa tem a agenda do Outlook conectada (mesma consulta da linha do dia). */
export function useOutlookConnected() {
  const today = localToday();
  return useOutlook(today, today).data?.connected ?? false;
}

/** Evento da equipe abre a folha; compromisso do Outlook abre no próprio Outlook. */
export function openAgendaEvent(e: AgendaEvent) {
  if (e.external) { if (e.url) window.open(e.url, '_blank', 'noopener'); return; }
  openSheet({ kind: 'event', id: e.id });
}
